import request from './request';
/**
 *  获取到店提醒列表
 */
export function getArriveReminds(params) {
    return request('/arrive/reminds', {
        method: 'POST',
        params,
    });
}

/**
 *  提醒设置
 */
export function setReminds(params) {
    return request('/arrive/reminds/setting', {
        method: 'PUT',
        params,
    });
}

/**
 *  跟进备注
 */
export function setRemindsRemark(params) {
    return request('/arrive/reminds/remark', {
        method: 'POST',
        params,
    });
}

/**
 *  获取客户到店详情
 */
export function getArriveDetail(params) {
    return request(`/arrive/reminds/${params}`, {
        method: 'GET',
    });
}

/**
 *  提醒人下拉
 */
export function getRemindPerson(params) {
    return request(`/arrive/remind-person/${params}`, {
        method: 'GET',
    });
}

/**
 *  获取提醒设置
 */
export function getRemindsSetting(params) {
    return request(`/arrive/reminds/setting/${params}`, {
        method: 'GET',
    });
}

/**
 *  查询操作记录
 */
export function getRemindRecords(params) {
    return request(`/arrive/reminds/records/${params.id}`, {
        method: 'GET',
        params: {
            pageNum: params.pageNum,
            pageSize: params.pageSize,
        },
    });
}

/**
 *  跟进备注
 */
export function getHistoryBusiness(params) {
    return request('/booking-data/history-business', {
        method: 'GET',
        params,
    });
}
